import React from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './style.css';

function Link({ ...props }) {
  return (
    <a href={props.href} target="_blank" rel="noreferrer">
      {props.href}
    </a>
  );
}

export default function MarkdownComponent({ text = '', outdated = false }) {
  /* eslint-disable react/no-children-prop */
  return (
    <Markdown
      children={text}
      remarkPlugins={[remarkGfm]}
      components={{
        a: Link,
      }}
      className={outdated ? 'prompt-markdown-container-outdated' : 'default'}
    ></Markdown>
  );
}
